module.exports = __webpack_public_path__ + "img/pc_sign.5d6c38e0.png";